import { SMSIconFilled } from '@rsos/assets/icons';
import ToastBanner from '../base/Toast/ToastBanner';
import styles from './InteragencyChatToast.module.css';

export interface InteragencyChatToastProps {
  /**
   * Display name of the conversation, or null when it is not known (e.g. the
   * conversation list has not caught up to a brand-new conversation yet).
   */
  conversationName: string | null;
  messagePreview: string;
  onOpen: () => void;
}

/**
 * Toast content for a new message in a subscribed interagency conversation.
 * Provides the conversation name and message preview to the shared
 * ToastBanner layout; clicking the banner or its View button opens the
 * conversation.
 */
function InteragencyChatToast({
  conversationName,
  messagePreview,
  onOpen,
}: InteragencyChatToastProps) {
  return (
    <ToastBanner
      dataName="interagency-chat-toast"
      icon={<SMSIconFilled data-name="interagency-chat-toast-icon" />}
      buttonText="View"
      buttonDataName="interagency-chat-toast-view-button"
      onAction={onOpen}
    >
      <span className={styles.title} data-name="interagency-chat-toast-title">
        {conversationName ? `Agency Chat: ${conversationName}` : 'Agency Chat'}
      </span>
      <span
        className={styles.preview}
        data-name="interagency-chat-toast-preview"
      >
        {messagePreview}
      </span>
    </ToastBanner>
  );
}

export default InteragencyChatToast;
